module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavyrain-b979dc186d2545083cf430fac58c6c1e.webp";